module.exports = __webpack_public_path__ + "de77a722/img/grid-web-icon.d0395d64.svg";